/**
 * Large increase:
 * - From 0 to 1000+ lbs usage
 * - Or, current is more than 3x and +1000 lbs of prior.
 */
export function isLargeIncrease(currentUsage: number, priorUsage: number): boolean {
  if (priorUsage === 0 && currentUsage >= 1000) {
    return true;
  }

  return currentUsage >= priorUsage * 3 && currentUsage - priorUsage >= 1000;
}

/**
 * Large decrease:
 * - From 1000+ lbs to 0 lbs
 * - Or, current is not discontinued and less than 3x of prior and -1000 lbs of prior.
 */
export function isLargeDecrease(currentUsage: number, priorUsage: number): boolean {
  if (priorUsage >= 1000 && currentUsage === 0) {
    return true;
  }

  return priorUsage > 0 && currentUsage > 0 && currentUsage <= priorUsage / 3 && priorUsage - currentUsage >= 1000;
}
